<template>
    <v-container style="padding-top: 100px;" id="Busqueda">
        <div v-if="show == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-card>
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Búsqueda Avanzada</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid" lazy-validation ref="formreporte">
                    <v-row>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Nombre del Asegurado:</span>
                            <v-text-field v-model="busqueda.asnombre" outlined width="20px" dense></v-text-field>
                            <span style="font-weight: bold;">Nombre del Conductor:</span>
                            <v-text-field v-model="busqueda.svnomcond" outlined width="20px" dense></v-text-field>
                            <span style="font-weight: bold;">Número Económico:</span>
                            <v-text-field v-model="busqueda.danumeco" outlined width="20px" dense></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Número de Serie:</span>
                            <v-text-field v-model="busqueda.svserie" outlined width="20px" dense></v-text-field>
                            <span style="font-weight: bold;">Correo Electrónico:</span>
                            <v-text-field v-model="busqueda.svemail" outlined width="20px" dense></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Averiguación Previa:</span>
                            <v-text-field v-model="busqueda.svnumave" outlined width="20px" dense></v-text-field>
                            <span style="font-weight: bold;">Número de Siniestro:</span>
                            <v-text-field v-model="busqueda.svnumsin" outlined width="20px" dense></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Número de Póliza:</span>
                            <v-text-field v-model="busqueda.dapoliza" outlined width="20px" dense></v-text-field>
                            <span style="font-weight: bold;">Número de Placas:</span>
                            <v-text-field v-model="busqueda.svplaca" outlined width="20px" dense></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <div mt-2>
                    <v-btn class="mr-4" color="#536DFE" @click="Buscar(); numpag = 1; pagina = 1"
                        style="color:white">Buscar</v-btn>
                    <v-btn class="mr-4" @click="limpiar" color="default">Limpiar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
        <v-card class="mt-2" v-if="verlistado">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-3">mdi-magnify</v-icon>
                <p style="color: white">Reportes</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <div class="table-responsive">
                    <table :id="tableName" class="table table-hover display responsive no-wrap" width="100%">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="encabezado in headers" :key="encabezado.id">
                                    {{ encabezado.text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="reporte in reportes" :key="reporte.id">
                                <td></td>
                                <td
                                    v-if="reporte.aiclave == 1 || reporte.aiclave == 23 || reporte.aiclave == 24 || reporte.aiclave == 5 || reporte.aiclave == 26 || reporte.aiclave == 27">
                                    <a class="link" @click="BuscarReporte(reporte, $event)">{{ reporte.nrreporte }}</a>
                                </td>
                                <td v-else>{{ reporte.nrreporte }}</td>
                                <td>{{ reporte.asnombre }}</td>
                                <td>{{ reporte.svnomcond }}</td>
                                <td>{{ reporte.svserie }}</td>
                                <td>{{ reporte.svemail }}</td>
                                <td>{{ reporte.svnumave }}</td>
                                <td>{{ reporte.svnumsin }}</td>
                                <td>{{ reporte.dapoliza }}</td>
                                <td>{{ reporte.svplaca }}</td>
                                <td>{{ reporte.prnombre }}</td>
                                <td>{{ reporte.clnombrecorto }}</td>
                                <td>{{ reporte.ainombre }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <template>
                        <v-row>
                            <v-col cols="12" md="6" sm="12">
                                <div class="ml-2 text-center select-registros">
                                    <label>Mostrar </label>
                                    <v-select v-model="numreg" :items="regpagina" style="max-width: 60px"
                                        class="ml-2 my-custom-select" name="numreg" id="numreg" dense></v-select>
                                    <label>registros</label>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <div class="pt-2 div-paginacion">
                                    <v-pagination v-model="pagina" prev-icon="mdi-chevron-double-left"
                                        next-icon="mdi-chevron-double-right" :length="numpaginas" :total-visible="5"
                                        name="pagina" id="pagina" @input="onPageChange">
                                    </v-pagination>
                                </div>
                            </v-col>
                        </v-row>
                    </template>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import GDDetalle from '@/components/pages/GestoriaDoc/Detalle.vue';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import "datatables.net-responsive-dt";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        GDDetalle
    },
    data: function () {
        return {
            busqueda: {
                asnombre: null,
                svnomcond: null,
                svserie: null,
                svemail: null,
                svnumave: null,
                svnumsin: null,
                dapoliza: null,
                svplaca: null,
                danumeco: null
            },
            show: false,
            loading: true,
            numreg: 20,
            numpaginas: 0,
            numpag: 1,
            headers: [
                { text: 'Reporte', value: 'nrreporte', class: "text title" },
                { text: 'Asegurado', value: 'asnombre', class: "text title" },
                { text: 'Conductor', value: 'svnomcond', class: "text title" },
                { text: 'Serie', value: 'svserie', class: "text title" },
                { text: 'Correo', value: 'svemail', class: "text title" },
                { text: 'Averiguación previa', value: 'svnumave', class: "text title" },
                { text: 'Número de siniestro', value: 'svnumsin', class: "text title" },
                { text: 'Póliza', value: 'dapoliza', class: "text title" },
                { text: 'Placas', value: 'svplaca', class: "text title" },
                { text: 'Abogado', value: 'prnombre', class: "text title" },
                { text: 'Cliente', value: 'clnombrecorto', class: "text title" },
                { text: 'Asistencia', value: 'ainombre', class: "text title" },
            ],
            pagina: 1,
            reportes: [],
            regpagina: [20, 50, 100,],
            verlistado: false,
            valid: true,
            prefix: "tabla_",
            randomNum: Math.floor(Math.random() * 1000),
        };
    },
    props: [],
    watch: {
        numreg(nuevoValor) {
            this.verlistado = false;
            this.numreg = nuevoValor;
            this.numpag = 1;
            this.pagina = 1;
            this.Buscar()
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
        tableName() {
            return this.prefix + this.randomNum;
        },
    },

    methods: {
        limpiar() {
            this.verlistado = false;
            this.$refs.formreporte.reset();
        },
        onPageChange() {
            this.numpag = this.pagina;
            this.Buscar();
        },
        async Buscar() {
            if (this.busqueda.asnombre == null && this.busqueda.svnomcond == null && this.busqueda.svserie == null && this.busqueda.svemail == null &&
                this.busqueda.svnumave == null && this.busqueda.svnumsin == null && this.busqueda.dapoliza == null && this.busqueda.svplaca == null &&
                this.busqueda.danumeco == null) {
                this.show = false;
                this.$swal({
                    position: 'center',
                    icon: 'info',
                    title: 'Campos incompletos.',
                    text: 'Debe de llenar al menos un campo',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    timer: 3500,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            } else {
                this.show = true;
                $("#" + this.tableName + "_paginate").empty();
                $("#" + this.tableName + "_info").remove();
                $("#" + this.tableName + "_filter").remove();
                this.randomNum = Math.floor(Math.random() * 1000);
                this.verlistado = false;
                var datosbusqueda = new FormData();
                const { asnombre, svnomcond, svserie, svemail, svnumave, svnumsin, dapoliza, svplaca, danumeco } = this.busqueda
                datosbusqueda.append("asnombre", asnombre);
                datosbusqueda.append("svnomcond", svnomcond);
                datosbusqueda.append("svserie", svserie);
                datosbusqueda.append("svemail", svemail);
                datosbusqueda.append("svnumave", svnumave);
                datosbusqueda.append("svnumsin", svnumsin);
                datosbusqueda.append("dapoliza", dapoliza);
                datosbusqueda.append("svplaca", svplaca);
                datosbusqueda.append("numreg", this.numreg);
                datosbusqueda.append("numpag", this.numpag);
                datosbusqueda.append("danumeco", danumeco);

                this.numpaginas = await SerBusqueda.BusquedaAvanzada_Tam(this, datosbusqueda);
                let aux_listado = await SerBusqueda.BusquedaAvanzada(this, datosbusqueda)
                for (let i in aux_listado) {
                    for (const [key, value] of Object.entries(aux_listado[i])) {
                        if (typeof value === "object") { aux_listado[i][key] = "" } else { aux_listado[i][key] = value.toString() }
                    }
                }
                this.reportes = aux_listado
                for (let i in this.reportes) {
                    this.reportes[i].nrreporte = this.reportes[i].nrreporte + '-' + this.reportes[i].svindice
                }

                this.verlistado = true;
                this.show = false;

                setTimeout(() => {
                    $(`#${this.tableName}`).DataTable({
                        paginate: this.paginacion,
                        pageLength: this.numreg,
                        responsive: {
                            details: {
                                type: 'column'
                            }
                        },
                        columnDefs: [{
                            className: 'dtr-control',
                            orderable: false,
                            targets: 0
                        }],
                        order: [1, 'asc'],
                        searching: false,
                        language: {
                            sProcessing: "Procesando...",
                            sLengthMenu: "Mostrar _MENU_ registros",
                            sZeroRecords: "No se encontraron resultados",
                            sEmptyTable: "Sin registros encontrados",
                            sInfo: "",
                            sInfoEmpty: "",
                            sInfoFiltered: "",
                            sInfoPostFix: "",
                            search: "",
                            searchPlaceholder: "Filtrar...",
                            sUrl: "",
                            sInfoThousands: ",",
                            sLoadingRecords: "Cargando...",
                            oPaginate: {
                                sFirst: "Primero",
                                sLast: "Último",
                                sNext: "Siguiente",
                                sPrevious: "Anterior",
                            },
                            oAria: {
                                sSortAscending:
                                    ": Activar para ordenar la columna de manera ascendente",
                                sSortDescending:
                                    ": Activar para ordenar la columna de manera descendente",
                            },
                        },
                    });
                });
            }
        },
        async BuscarReporte(item) {
            let aux = item.nrreporte.split('-');
            let _svindice = aux[1];
            let _nrreporte = aux[0];

            let reporte = {
                nrreporte: _nrreporte,
                svindice: _svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };
            if (item.aiclave != 26) {
                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", _nrreporte);
                formData.append("svindice", _svindice);

                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data.length;
                });
                if (ver == 0) {
                    this.$router.push({ name: `${"DatosIncompletos"}` });
                }
                else {
                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    this.$router.push({ name: `${"Asistencias"}` });
                }
            } else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ name: `${"Asistencias"}` });
            }

        },
    },

};
</script>
<style>
#Busqueda .theme--light.v-card>.v-card__text,
.theme--light.v-card>.v-card__subtitle {
    color: rgba(0, 0, 0, 1);
}

#Busqueda .theme--dark.v-card>.v-card__text,
.theme--dark.v-card>.v-card__subtitle {
    color: rgba(255, 255, 255, 1);
}

.select-registros {
    display: flex;
    justify-content: left;
    align-items: baseline;
}

.div-paginacion {
    display: flex;
    justify-content: right;
    align-items: center;
}

@media screen and (max-width: 767px) {
    .select-registros {
        display: flex;
        justify-content: center;
        align-items: baseline;
    }

    .div-paginacion {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>

